import { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import api from "@/lib/api";
import ProductCard from "@/components/ProductCard";

export default function SearchPage() {
  const [params] = useSearchParams();
  const q = params.get("q") || "";
  const [products, setProducts] = useState([]);

  useEffect(() => {
    if (!q) return;
    api.get(`/products?q=${encodeURIComponent(q)}`).then((r) => setProducts(r.data));
  }, [q]);

  return (
    <div className="max-w-7xl mx-auto px-6 md:px-12 py-16" data-testid="search-page">
      <p className="label-eyebrow mb-3">Results for</p>
      <h1 className="font-serif text-5xl tracking-tighter mb-12">"{q}"</h1>
      {products.length === 0 ? (
        <p className="text-[#6A747D]">No matches.</p>
      ) : (
        <div className="grid grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-x-8 gap-y-12">
          {products.map((p, i) => <ProductCard key={p.id} product={p} index={i} />)}
        </div>
      )}
    </div>
  );
}
